var _circle, _g, _circle2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessageIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.25,
    cy: 18,
    r: 18,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4301 10.41C23.4301 9.08 24.5101 8 25.8401 8C27.1701 8 28.2501 9.08 28.2501 10.41C28.2501 11.74 27.1701 12.82 25.8401 12.82C24.5101 12.82 23.4301 11.74 23.4301 10.41ZM19.58 20.7593L22.47 17.0303L22.43 17.0503C22.59 16.8303 22.62 16.5503 22.51 16.3003C22.401 16.0503 22.16 15.8803 21.901 15.8603C21.63 15.8303 21.361 15.9503 21.2 16.1703L18.781 19.3003L16.01 17.1203C15.84 16.9903 15.64 16.9393 15.44 16.9603C15.241 16.9903 15.061 17.0993 14.94 17.2593L11.981 21.1103L11.92 21.2003C11.75 21.5193 11.83 21.9293 12.13 22.1503C12.27 22.2403 12.42 22.3003 12.59 22.3003C12.821 22.3103 13.04 22.1893 13.18 22.0003L15.69 18.7693L18.54 20.9103L18.63 20.9693C18.95 21.1393 19.35 21.0603 19.58 20.7593ZM21.7 9.7803C21.66 10.0303 21.64 10.2803 21.64 10.5303C21.64 12.7803 23.46 14.5993 25.7 14.5993C25.95 14.5993 26.19 14.5703 26.44 14.5303V22.5993C26.44 25.9903 24.44 28.0003 21.04 28.0003H13.651C10.25 28.0003 8.25 25.9903 8.25 22.5993V15.2003C8.25 11.8003 10.25 9.7803 13.651 9.7803H21.7Z",
    fill: "#030229"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.7502,
    cy: 10.5,
    r: 2.5,
    fill: "#EB5757"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIcon);
export default __webpack_public_path__ + "static/media/message-icon.4dd418958f2d51fa85e8fde4673a5196.svg";
export { ForwardRef as ReactComponent };